import { render, staticRenderFns } from "./traslados.vue?vue&type=template&id=607a723c&"
import script from "./traslados.vue?vue&type=script&lang=js&"
export * from "./traslados.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports